import { Component, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { EventViewerService } from '@app/services/event-viewer.service';
import { MpSessionsService } from '@app/services/mp-sessions.service';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_card_event_viewer_time_line_input_area_component',
    templateUrl: './c_card_event_viewer_time_line_input_area.component.html',
    styleUrls: ['./c_card_event_viewer_time_line_input_area.component.scss'],
    standalone: false
})
export class c_card_event_viewer_time_line_input_area_component extends BaseComponent {
  @ViewChild('memoTextArea') memoTextArea: ElementRef<HTMLTextAreaElement>;
  @Input() log: any
  @Input() isMode: string; // 'print' | 'create' | 'view'

  maxRows = 3; // 최대 허용 행 수
  maxLength = 160; // 고정하자.
  noteLength = 0;
  noteList = [];
  isShowErr = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private eventViewerService: EventViewerService,
    private mpSessionsService: MpSessionsService,
  ) { super(); }

  ngAfterViewInit(): void {
    this.adjustTextArea()
    this.cdr.detectChanges(); // 수동으로 변경 감지 실행
  }

  // -------------------------------------------
  // TEXTAREA
  adjustTextArea(): void {
    if(!this.memoTextArea?.nativeElement) return

    this.memoTextArea.nativeElement.style.height = '80px';
    this.maxRows = 3;
    this.maxLength = 160; 
  }

  checkTextarea(inputEvent: Event) {
    const textarea = inputEvent.target as HTMLTextAreaElement;
    const lines = textarea.value.split('\n');
    this.noteLength = textarea.value.length;
    const height = 80
    this.isShowErr = false;
    this.eventViewerService.isShowErrInTextArea = false;
    this.mpSessionsService.isShowErrInTextArea = false;

    if (this.memoTextArea.nativeElement.scrollHeight > height) {
      textarea.value = textarea.value.substring(0, textarea.value.length - 1);
      this.isShowErr = true;
      this.eventViewerService.isShowErrInTextArea = true;
      this.mpSessionsService.isShowErrInTextArea = true;
    }

    if (lines.length > this.maxRows) {
      textarea.value = lines.slice(0, this.maxRows).join('\n'); // 초과된 내용을 제거
    }
  }
}
